export default function Declined() {
  return (
    <div
      className="status_card"
      style={{ border: "1px solid #FFE1F5", backgroundColor: "#FCEFF7" }}
    >
      <div className="titleBar">
        <img src="/images/potential-deals/status/declined.svg" alt="" />
      </div>
      <h5> Proposal declined </h5>
      <h6> The customer declined this proposal. </h6>
    </div>
  );
}
